import { VisitedServices } from 'types';

export const formatServicesForAPI = (services: VisitedServices[]) => {
  const formattedServices: Record<string, number> = {};

  services.forEach((service, index) => {
    formattedServices[`services[${index}][id]`] = service.id;
    formattedServices[`services[${index}][provider]`] = service.provider;
    const { attendees } = service;
    if (attendees !== null && Array.isArray(attendees)) {
      attendees.forEach((attendee, attendeeIndex) => {
        formattedServices[`services[${index}][attendees][${attendeeIndex}]`] =
          attendee;
      });
    }
  });
  return formattedServices;
};
